var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"pa-5 mt-8"},[_c('v-sheet',{staticClass:"text-start mb-n6 pa-7 v-card-heading",attrs:{"dark":true,"elevation":"6","color":"teal"}},[_vm._t("heading")],2),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }